import { appDataReducerPaginationAndSearch } from './reducerMetadata';

// Overview of all companies
export function appDataReducerCompanies(state, action) {
    const meta = appDataReducerPaginationAndSearch(action.companies.message.meta);

    const companies = action.companies.message.data.map((data) => ({
        id: data.id,
        name: data.name,
        debtorNumber: data.debtor_number,
    }));

    return {
        meta,
        items: companies,
    };
}

// Detail of one company
export function appDataReducerCompany(state, action) {
    const companyDetail = action.company.message.data;

    // Categorize the administrations per license id
    const categorizedAdministrations = {};
    companyDetail.administrations.forEach((administration) => {
        // Add category to the object if it doesn't exist yet
        if (typeof categorizedAdministrations[administration.license_id] == 'undefined') {
            categorizedAdministrations[administration.license_id] = [];
        }

        categorizedAdministrations[administration.license_id].push({
            id: administration.id,
            type: administration.type,
            name: administration.name,
            activeChildren: administration.children_active,
            activeChildrenChildminder: administration.children_active_childminder,
            activeChildrenTsoOnly: administration.children_active_tso_only,
            online: administration.online,
            dbVersion: administration.flexkids_version,
            environment: administration.environment,
            licenseId: administration.license_id,
        });
    });

    // It's possible the company has administrations connected to it that are not connected to any of the licenses of the company
    const administrationsWithoutThisCompanyLicense = { ...categorizedAdministrations };
    // It's also possible the company has administrations that are not connected to any license at all, which will be collected and
    // send to the view separately
    delete administrationsWithoutThisCompanyLicense['null'];

    const companyLicenses = companyDetail.licenses.map((license) => {
        // This license is connected to the company, so delete it from the collection of licenses which are not
        delete administrationsWithoutThisCompanyLicense[license.id];

        return {
            id: license.id,
            description: license.description,
            expiresOn: license.expires_on,
            readOnly: license.readonly,
            activeChildren: license.children_registered,
            maxChildren: license.children_max,
            idpOrganizationId: license.idp_organization_id,
            administrations: categorizedAdministrations[license.id],
            amountOfAdministrations:
                typeof categorizedAdministrations[license.id] != 'undefined'
                    ? categorizedAdministrations[license.id].length
                    : 0,
        };
    });

    // The relevant administrations are incorrect behaviour. For the call-to-action alert, display the names of the administrations
    const administrationsWithoutThisCompanyLicenseNames = [];
    for (const administrationId in administrationsWithoutThisCompanyLicense) {
        administrationsWithoutThisCompanyLicense[administrationId].forEach((administration) => {
            administrationsWithoutThisCompanyLicenseNames.push(administration.name);
        });
    }

    return {
        id: companyDetail.id,
        name: companyDetail.name,
        debtorNumber: companyDetail.debtor_number,
        createdAt: companyDetail.created_at,
        updatedAt: companyDetail.updated_at,
        licenses: companyLicenses,
        administrations: {
            withoutLicense: categorizedAdministrations['null'],
            withoutThisCompanyLicense: administrationsWithoutThisCompanyLicenseNames,
        },
    };
}

// New company
export function appDataReducerNewCompany(state, action) {
    return action;
}
